import React from 'react';
import { teamMembers } from '../../data/team';
import { TeamMemberCard } from './TeamMemberCard';
import { Reveal } from '../motion/Reveal';
type TeamGridProps = {
  compact?: boolean;
};
export function TeamGrid({
  compact = false
}: TeamGridProps) {
  if (compact) {
    return <ul className="grid grid-cols-1 gap-4 min-[480px]:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 lg:gap-5" data-id="element-279" data-mp="apl0154v5cqk">
        {teamMembers.map((member, index) => <Reveal as="li" key={member.id} delay={index * 70} className="flex" data-id="element-280" data-mp="3t2j67ts911t6" data-mpi={index}>
            <TeamMemberCard member={member} compact data-id="element-281" data-mp="1py7z9y0xja6" />
          </Reveal>)}
      </ul>;
  }
  return <ul className="flex flex-wrap justify-center gap-5 lg:gap-6" data-id="element-282" data-mp="3j7hgavq5fvpj">
      {teamMembers.map((member, index) => <Reveal as="li" key={member.id} delay={index * 70} className="flex w-full sm:w-[calc(50%-10px)] lg:w-[calc(33.333%-16px)]" data-id="element-283" data-mp="3o2n1ttfn38d3" data-mpi={index}>
          <TeamMemberCard member={member} data-id="element-284" data-mp="3e61wf6zpjv8q" />
        </Reveal>)}
    </ul>;
}